import { render, staticRenderFns } from "./ContactsEdit.vue?vue&type=template&id=bf5bc9a8&scoped=true"
import script from "./ContactsEdit.vue?vue&type=script&lang=js"
export * from "./ContactsEdit.vue?vue&type=script&lang=js"
import style0 from "./ContactsEdit.vue?vue&type=style&index=0&id=bf5bc9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bc9a8",
  null
  
)

export default component.exports